import { EnterpriseLicenseType } from '@trello/enterprise';

interface IsLicensedEnterpriseMemberArgs {
  enterpriseLicenses?:
    | {
        idEnterprise?: string;
        type?: EnterpriseLicenseType;
      }[]
    | null;
}

/**
 * A user is considered to have a license when:
 *  - The user has an idEnterprise
 *  - The type of license is either "team" or "collaborator"
 */
export const isLicensedEnterpriseMember = ({
  enterpriseLicenses,
}: IsLicensedEnterpriseMemberArgs): boolean => {
  if (!enterpriseLicenses) {
    return false;
  }
  return Boolean(
    enterpriseLicenses.filter((license) => {
      return license.type === 'team' || license.type === 'collaborator';
    }).length > 0,
  );
};
